"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitAttributionEventMessageSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.SubmitAttributionEventMessageSchema = (0, core_1.StrictObject)({
    key: typebox_1.Type.Optional(ruby_1.AttributionSecretKeySchema),
    currency: typebox_1.Type.Optional(core_1.CurrencySchema),
    ...ruby_1.ExternalAttributionEventFields,
});
